<template>
  <de-layout-content>
    <div class="app-container">
      <div class="question_box dark-theme">
        <div class="left_nav">
          <div class="bl_title" @click="cancelQuesTemp"><i class="el-icon-back"></i>{{ enter == 1 ? '调查问卷' : '问卷模版' }}
          </div>
          <!-- <div class="navLine" v-if="enter == 1">
          <ul>
            <li v-for="(item, index) in navData" :key="index">
              <div class="txt" @click="navJump(item)">{{ item.templateName }}</div>
            </li>
          </ul>
        </div> -->
          <div class="queNavLine">
            <el-tree ref="tree" default-expand-all class="filter-tree" node-key="id" :data="newTempArr"
              :props="defaultProps" :highlight-current="true" :check-strictly="true" :expand-on-click-node="false"
              @node-click="treeTempSelect">
            </el-tree>

            <!-- <div class="aBtn">我创建的<i class="el-icon-caret-bottom"></i></div>
          <ul>
            <li v-for="(item, index) in queTemplateManagementVoList" :key="index">
              <div class="txt" @click="navJump(item)">{{ item.templateName }}</div>
            </li>
          </ul>
          <div class="aBtn">系统默认<i class="el-icon-caret-bottom"></i></div>
          <ul>
            <li v-for="(item, index) in queTemplateManagementVoSysList" :key="index">
              <div class="txt" @click="navJump(item)">{{ item.templateName }}</div>
            </li>
          </ul> -->
          </div>
        </div>
        <div class="right_main">
          <div class="topControl">
            <div class="conLeft">
              <div class="questionSut" v-if="enter == 1">
                状态
                <span v-if="quesDetail.isPull == 1">
                  <i></i>未发布
                </span>
                <span v-else="quesDetail.isPull == 2">
                  <i class="sutBored_2"></i>已发布
                </span>
              </div>
            </div>
            <div class="conCenter">
              <div class="terminal">
                <div class="odd" @click="terminalTab(1)" :class="{ active: terminalActive == true }">
                  <i class="el-icon-monitor"></i>
                </div>
                <div class="odd" @click="terminalTab(2)" :class="{ active: terminalActive == false }">
                  <i class="el-icon-mobile"></i>
                </div>
              </div>
            </div>
            <div class="conRight">
              <div v-if="typeRoleVal != 1">
                <el-button size="small" type="primary" @click="setTemplate"
                  v-if="enter == 1 && quesDetail.isPull == 1 || enter == 2 && editType == 2" icon="el-icon-edit"
                  plain>编辑</el-button>
                <el-button size="small" plain type="danger" icon="el-icon-delete" @click="baseBtn(a, 1)"
                  v-if="enter == 1 || enter == 2 && editType == 2">删除</el-button>
                <el-button size="small" type="primary" icon="el-icon-s-claim" @click="appliesTemp"
                  v-if="enter == 2">应用模板</el-button>
              </div>
              <div v-if="typeRoleVal == 1">
                <el-button size="small" type="primary" @click="setTemplate"
                  v-if="enter == 1 && quesDetail.isPull == 1 || enter == 2" icon="el-icon-edit" plain>编辑</el-button>
                <el-button size="small" plain type="danger" icon="el-icon-delete" @click="baseBtn(a, 1)">删除</el-button>
                <el-button size="small" type="primary" icon="el-icon-setting" @click="setTemplateAuthor"
                  v-if="enter == 2">设置权限</el-button>
              </div>
              <el-button size="small" plain type="success" icon="el-icon-position" @click="baseBtn(b, 2)"
                v-if="enter == 1 && quesDetail.isPull == 1">发布</el-button>
            </div>
          </div>
          <div :class="terminalActive == false ? 'preview_mobile' : ''">
            <img class="mobileImg" v-if="terminalActive == false" :src="previewMobile">
            <template v-if="!is_finish">
              <div class="question_content">
                <div class="quesTitle">《{{ quesDetail.templateName }}》</div>
                <div class="subtitle">共{{ questionList.length }}题,已完成{{ finish }}题</div>
                <div class="explainInfo">指导语：{{ quesDetail.explainInfo }}</div>
                <div class="question_lists" v-if="questionList && questionList.length > 0">
                  <Topic :selectItemS="selectItemS" :topicData="questionList" :editeSut="editeSut"
                    @showModal="showModal" @delModal="delModal" @change="change" />
                </div>
              </div>
            </template>
            <template v-else>
              <a-empty :image="complete_img" :description="'今日已完成该问卷'" />
            </template>
          </div>
        </div>
      </div>

      <!-- 问卷模版创建 -->
      <el-dialog title="应用模板" :visible.sync="queTemplateDialog" width="800px" custom-class="queTemplateDialog">
        <el-form ref="queTemplateForm" :rules="queTemplateRules" :model="queTemplateForm" label-width="80px">
          <el-form-item label="问卷标题" prop="templateName">
            <el-input v-model="queTemplateForm.templateName" placeholder="请输入问卷标题" clearable></el-input>
          </el-form-item>
          <el-form-item label="问卷类型" class="typeElForm" prop="queType">
            <el-select v-model:value="queTemplateForm.queType" placeholder="请选择问卷类型" clearable>
              <el-option v-for="(item, index) in queTypeArr" :key="index" :label="item.name" :value="item.id" />
            </el-select>
            <!-- <div class="typeMesgBtn" @click="typeMsgBtn">类型管理</div> -->
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer dialogBoredTop">
          <el-button @click="queTemplateDialog = false">取 消</el-button>
          <el-button type="primary" @click="queTemplateSave">保 存</el-button>
        </div>
      </el-dialog>

      <!-- 确认提示 -->
      <el-dialog title="提示" :visible.sync="dialogVisibleConfPrompt" width="30%">
        <span>{{ confTxt }}</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleConfPrompt = false">取 消</el-button>
          <el-button type="primary" @click="confPromptBtn">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 设置权限弹窗-start -->
      <el-dialog title="设置权限" :visible.sync="showSetting" width="800px" append-to-body>
        <div class="settingCont">
          <div class="flxL mr20">
            <el-checkbox v-model="menuNodeAll" @change="selectAll($event)">全选/全不选</el-checkbox>
            <div class="treeCont">
              <el-tree ref="tree" node-key="id" show-checkbox default-expand-all :data="treeData" :props="defaultProps2"
                :default-checked-keys="checkKeys" @check-change="getCheck">
              </el-tree>
            </div>
          </div>
          <div class="flxR">
            <div class="preShow">
              <span>已选{{ checkNodes.length }}</span>
              <span class="clear" @click="clearNode">清空</span>
            </div>
            <div class="nodeList">
              <div class="node" v-for="(item, index) in checkNodes" :key="index">{{ item.name }}</div>
            </div>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="showSetting = false">取 消</el-button>
          <el-button type="primary" @click="setSubmit">确定</el-button>
        </div>
      </el-dialog>
      <!-- 设置权限弹窗-end -->

    </div>
  </de-layout-content>
</template>

<script>
import Topic from '../../workBench/components/Topic.vue';
import * as API_Ques from "@/api/dataAccess/questionnaire";
import { message, Modal } from "ant-design-vue";
export default {
  components: {
    Topic
  },
  data() {
    return {
      id: this.$route.query.id,
      enter: this.$route.query.enter,
      editType: null,
      selectItemS: {},
      editeSut: false,
      previewMobile: require('@/assets/iphone15proMax.png'),

      // 确认提示
      dialogVisibleConfPrompt: false,
      confTxt: '',
      baseType: null,

      // userType: this.$store.state.loginInfo.type,  //用户类型
      // userId: this.$store.state.loginInfo.id, //用户id
      questionTitle: '',
      questionType: '',
      questionList: [],
      quesDetail: {},
      finish: 0,
      is_finish: false,
      complete_img: require("@/assets/xxp-img/ywc.png"),
      terminalActive: true,

      // navData: [],
      newTempArr: [],
      defaultProps: {
        label: 'templateName',
      },
      queTypeArr: [],
      queTemplateDialog: false,
      queTemplateForm: {
        templateName: '',
        queType: undefined
      },
      queTemplateRules: {
        queType: [
          { required: true, message: '请选择问卷类型', trigger: 'change' },
        ],
        templateName: [
          { required: true, message: '请输入问卷名称', trigger: 'blur' },
        ],
      },
      typeRoleVal: null, //系统角色

      // 设置权限-start
      checkKeys: [],
      checkNodes: [],
      showSetting: false,
      defaultProps2: {
        children: 'children',
        label: 'name',
      },
      treeData: [],
      queTemplateId: null,
      setForm: {
        organizationIdS: [],
      },
      // 设置权限-end
    }
  },
  methods: {

    // 展示确认删除&发布弹窗
    baseBtn(e, i) {
      this.baseType = i
      this.dialogVisibleConfPrompt = true
      if (i == 1) {
        this.confTxt = '确认要删除“' + this.quesDetail.templateName + '”数据？'
      } else {
        this.confTxt = '确认要发布“' + this.quesDetail.templateName + '”数据？'
      }
    },

    // 弹窗确认发布/删除
    confPromptBtn() {
      if (this.baseType == 1) {
        // 删除
        let params = {
          ids: [this.id],
        }
        let url = this.enter == 1 ? 'templateDel' : 'queManagementDel'
        API_Ques[url](params).then(res => {
          if (res.code == 200) {
            this.$message.success('删除成功')
            this.dialogVisibleConfPrompt = false
            // this.getDetailNav()
            setTimeout(() => {
              if (this.enter == 1) { //删除问卷管理
                this.$router.push('/dataAccess/questionnaire/manageIndex')
              } else if (this.enter == 2) {
                this.$router.push('/dataAccess/questionnaire/templateIndex')
              }
            }, 500);
          }
        })
      } else {
        // 发布
        const params = {
          id: this.id,
          ispull: 2
        };
        API_Ques.queManagementisPull(params).then(res => {
          if (res.code == 200) {
            this.$message.success("发布成功");
            setTimeout(() => {
              this.$router.back()
            }, 500);
          }
        })
      }
    },

    // 问卷模板创建-保存
    queTemplateSave() {
      this.$refs["queTemplateForm"].validate((valid) => {
        if (valid) {
          const params = {
            queType: this.queTemplateForm.queType,
            templateName: this.queTemplateForm.templateName,
            templateManagementId: this.id,
            isUse: 2,
          }
          API_Ques.templateMsgAdd(params).then(res => {
            if (res.code == 200) {
              this.queTemplateDialog = false
              this.$message({
                message: "应用成功",
                type: "success",
              });
              setTimeout(() => {
                this.$router.back()
              }, 500);
            }
          })
        } else {
          this.$message({
            message: "填写数据不全或数据有误",
            type: "error",
          });
          return false;
        }
      });
    },

    // 左侧菜单跳转
    treeTempSelect(e, checked, indeterminate) {
      if (e.id) {
        this.selectItemS = {}
        this.questionList = []
        this.id = e.id
        this.editType = e.type
        this.getDetail()
        this.$refs.tree.setCheckedKeys([e.id])
        this.$router.push({
          name: "quesTemplatePreview",
          query: {
            id: e.id,
            enter: this.enter,
            editType: e.type,
          },
        });
        this.$forceUpdate();
      }
    },

    // 左侧点击选择
    // handleCheckedChange(data, checked, indeterminate) {
    //   if (checked) {
    //     this.$refs.tree.setCheckedKeys([data.id])
    //   }
    // },

    // 获取问卷类型
    getQueTypeArr() {
      API_Ques.getQueTypeList().then(res => {
        if (res.code == 200) {
          if (res.data.length > 0) {
            this.queTypeArr = res.data
            this.queTypeArr.forEach((ele, i) => {
              ele.label = ele.name
              ele.value = ele.id
            });
          } else {
            this.queTypeArr = []
          }
          // this.queTypeArr = res.data.length > 0 ? res.data : []
        }
      })
    },

    // 终端切换预览
    terminalTab(e) {
      if (e == 1) {
        this.terminalActive = true
      } else {
        this.terminalActive = false
      }
    },

    reset(form) {
      for (let key in form) {
        form[key].answer = '';
      }
    },
    submit(data) {
      if (this.questionType == 1 && this.finish < data.length) {
        this.$message.error('未回答完')
        return
      } else if (this.finish < 1) {
        this.$message.error('未回答完')
        return
      }
      let params = []
      data.map(item => {
        let answer_arr = []
        let answer_body = [{
          type: 'forward',
          keyPoints: []
        }, {
          type: 'back',
          keyPoints: []
        }]
        if (item.topicType == 3) {//多选，拼数据结构，后端要求的
          item.answer.map(res => {
            let obj = { answerId: res }
            answer_arr.push(obj)
          })
        } else if (item.topicType == 4) {  //人体图
          answer_body.map(ele => {
            let arr = []
            item.answer[ele.type].map(items => {
              arr.push(items.No)
            })
            ele.keyPoints = arr
          })
        }
        let obj = {
          topicType: item.topicType,
          queType: this.questionType,
          queId: item.id,
          answer: item.topicType == 4 ? JSON.stringify(answer_body) : ([2].includes(item.topicType) ? JSON.stringify([{ answerId: item.answer }]) : (item.topicType == 3 ? JSON.stringify(answer_arr) : item.answer))
        }
        params.push(obj)
      })
      this.$axios.post('/api/que/addAnswer', params).then(res => {
        if (res.code == 200) {
          this.$message.success('提交成功')
          this.$router.back()
        }
      })
    },
    change(data) {
      if (data && data.length > 0) {
        let i = 0;
        data.forEach((item, index) => {
          if (item.topicType == 4) {  //人体图
            if (item.answer.forward && item.answer.forward.length > 0 || item.answer.back && item.answer.back.length > 0) {
              i++
            }
          } else {
            if (item.answer && item.answer != '') {
              i++
            }
          }
        })
        this.finish = i;
      }
    },

    // 返回上一级
    cancelQuesTemp() {
      if (this.enter == 1) {
        this.$router.push({
          name: "manageIndex",
        });
      } else {
        this.$router.push({
          name: "templateIndex",
        });
      }
    },

    // 点击应用模板
    appliesTemp() {
      this.queTemplateDialog = true
    },

    // 点击编辑问卷模板
    setTemplate() {

      this.$router.push({
        name: "quesTemplateEdit",
        query: {
          id: this.id,
          enter: this.enter
        },
      });
    },

    // 获取详情数据
    getDetail() {
      let url = this.enter == 1 ? 'getQueInfo' : 'getQueTemplateInfo'
      API_Ques[url]({ 'id': this.id }, false, true).then(res => {
        this.quesDetail = res.data
        if (res.data.listl) {
          this.questionList = res.data.listl
          this.questionList.forEach((ele, i) => {
            if (ele.topicType == 1) {
              ele.slider_marks = {}
              ele.sliderMaxVal = null
              ele.optionVos.forEach((element, index) => {
                ele.slider_marks[index + 1] = element.remark
                ele.sliderMaxVal = index + 1
              })
            }
          });
          this.selectItemS = res.data.listl.filter(item => item.topicType === 4)
        }
      })
      this.getDetailNav()
    },

    // 获取左边菜单
    getDetailNav() {
      let urls = this.enter == 1 ? 'findQueTemplateList' : 'findQueTemplate'
      API_Ques[urls]().then(res => {
        if (res.code == 200) {
          if (this.enter == 1) { //问卷管理
            const parentArr = [
              {
                templateName: '系统默认',
                children: res.data,
                disabled: true
              }
            ]
            this.newTempArr = parentArr
            this.$refs.tree.setCheckedKeys([this.id])
          } else {
            if (this.typeRoleVal != 1) {
              const parentArr = [
                {
                  templateName: '我创建的',
                  children: [],
                  disabled: true
                },
                {
                  templateName: '系统默认',
                  children: [],
                  disabled: true
                },
              ]
              parentArr.forEach((ele, i) => {
                if (i == 0) {
                  ele.children = res.data.queTemplateManagementVoList.length > 0 ? res.data.queTemplateManagementVoList : []
                } else if (i == 1) {
                  ele.children = res.data.queTemplateManagementVoSysList.length > 0 ? res.data.queTemplateManagementVoSysList : []
                }
              });
              this.newTempArr = parentArr
              this.$refs.tree.setCheckedKeys([this.id])
            } else {
              const parentArr = [
                {
                  templateName: '系统默认',
                  children: [],
                  disabled: true
                }
              ]
              parentArr.forEach((ele, i) => {
                if (i == 0) {
                  ele.children = res.data.queTemplateManagementVoList.length > 0 ? res.data.queTemplateManagementVoList : []
                }
              });
              this.newTempArr = parentArr
              this.$refs.tree.setCheckedKeys([this.id])
            }


          }
        }
      })
    },

    // 点击设置模板-获取当前模板id的机构
    setTemplateAuthor() {
      this.queTemplateId = this.id
      const params = {
        queTemplateManagementId: this.id,
      };
      API_Ques.findSportsHallsListById(params).then(res => {
        this.showSetting = true
        this.checkNodes = res.data
        let checkKeys = res.data.map(item => item.id * 1)
        this.checkKeys = checkKeys
        this.$nextTick(() => {
          this.$refs.tree.setCheckedKeys(checkKeys, true)
        })
      })
    },

    // 权限操作弹窗-start
    getOrgList() {
      API_Ques.findSportsHallsList().then(res => {
        if (res.code == 200) {
          this.treeData = res.data.map(item => {
            return { ...item, id: item.id }
          })
        }
      })
    },
    selectAll(value) {
      this.$refs.tree.setCheckedNodes(value ? this.treeData : []);
    },
    clearNode() {
      this.checkKeys = []
      this.checkNodes = []
      this.$nextTick(() => {
        this.$refs.tree.setCheckedKeys([], true)
      })
    },
    getCheck() {
      this.checkNodes = this.$refs.tree.getCheckedNodes();
      this.checkKeys = this.checkNodes.map(item => item.id)
    },

    setSubmit() {
      if (!this.checkKeys.length) {
        this.$message({ message: '请设置模版权限', type: 'error' });
        return
      }
      const params = this.setForm
      params.organizationIdS = this.checkKeys
      params.queTemplateId = this.queTemplateId
      API_Ques.addTemplateJoin(params).then(res => {
        if (res.code == 200) {
          this.$message.success("操作成功");
          this.showSetting = false
          this._getList()
        }
      })
    },
    // 权限操作弹窗-end

  },
  created() {
    this.userRole = this.$store.state.user.roles.length && this.$store.state.user.roles[0].name || ''
    this.typeRoleVal = this.userRole == 'ADMIN' ? 1 : 2
    this.editType = this.$route.query.type

    this.getQueTypeArr()
    this.getDetail()
    this.getOrgList()
    // this.questionTitle = this.$route.query.title
    // this.questionType = this.$route.query.type
    // if (this.$route.query.queBatch) {
    //   this.getInfo()
    //   return
    // } else {
    //   this.getQuestion()
    // }
  }
}
</script>

<style lang="less" scoped>
::v-deep .filter-tree .el-tree-node {
  margin: 0 0;
  // padding: 3px 0;
}

::v-deep .filter-tree .el-tree-node__children .el-tree-node__expand-icon.is-leaf {
  display: none !important;
}

// ::v-deep .filter-tree>.el-tree-node>.el-tree-node__content>.el-tree-node__label {
//   font-weight: bold;
// }

::v-deep .el-tree {
  background-color: inherit;
  color: #fff;

  .el-tree-node__content {
    height: auto !important;
    flex-wrap: wrap;
    // padding: 3px 0;
  }

  .el-tree-node__children {
    .el-tree-node {
      .el-tree-node__content {
        padding: 5px 0;
      }
    }
  }

  .el-tree-node__content:hover {
    background-color: rgba(24, 144, 255, .1) !important;
  }

  .el-tree-node:focus>.el-tree-node__content {
    background-color: rgba(24, 144, 255, .1) !important;
  }

  &>.el-tree-node {
    white-space: break-spaces;
    &>.el-tree-node__content{
      padding: 5px 0;
      &>.el-icon-caret-right{
        font-size: 15;
      }
      &>.el-tree-node__label{
        font-size: 15px;
        color: rgba(255, 255, 255, .5);
      }
    }
  }

  span.el-tree-node__label {
    line-height: 24px;
    // width: 100%;
    display: inline-block;
    text-align: left;
    flex: 1;
  }
}

.question_box {
  // width: 80%;
  height: 100%;
  display: flex;
  align-items: flex-start;
  position: relative;
  margin-left: -20px;
  margin-right: -20px;
  margin-top: -10px;
  margin-bottom: -10px;

  .left_nav {
    width: 220px;
    height: 100%;
    // overflow-y: scroll;
    display: inline-block;
    padding: 0;
    box-sizing: border-box;
    // background-color: #21284B;

    .bl_title {
      display: flex;
      align-items: center;
      cursor: pointer;
      margin-bottom: 25px;

      i {
        font-size: 15px;
        margin-right: 2px;
      }

      &:hover {
        color: #1890ff;
      }
    }

    .queNavLine {
      margin-bottom: 25px;
      width: 100%;
      display: inline-block;
    }
  }

  .right_main {
    padding: 20px 20px 20px 0;
    flex: 1;
    border-left: 1px solid #21284B;
    min-height: 100%;
  }

  .topControl {
    display: flex;
    justify-content: space-between;
    margin-bottom: 30px;
    align-items: center;
    border-bottom: 1px solid #21284B;
    padding-left: 25px;
    padding-bottom: 20px;

    .conLeft {
      .questionSut {
        display: flex;
        align-items: center;
        color: #fff;

        span {
          margin: 10px;
          display: flex;
          align-items: center;

          i {
            width: 9px;
            height: 9px;
            display: inline-block;
            border-radius: 100%;
            margin-left: 7px;
            margin-right: 7px;
            background-color: #1890ff;
          }

          i.sutBored_2 {
            background-color: #38c5bc;
          }
        }
      }
    }

    .conCenter {
      .terminal {
        display: flex;

        .odd {
          border: 1px solid #fff;
          font-size: 20px;
          width: 40px;
          height: 36px;
          margin: 0 5px;
          border-radius: 5px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          cursor: pointer;

          &:hover {
            opacity: .7;
            border: 1px solid #1890ff;
          }

          i {
            color: #fff;
          }
        }

        .active {
          color: #1890ff;
          border: 1px solid #1890ff;

          i {
            color: #1890ff;
          }
        }
      }
    }

    .conRight {
      display: flex;

      button {
        margin-left: 10px;
      }
    }
  }

  // background: #141937;
  .question_content {
    width: 800px;
    padding-bottom: 80px;
    padding-left: 25px;
    box-sizing: border-box;
    color: #fff;

    .quesTitle {
      font-size: 20px;
      width: 100%;
      text-align: center;
      font-weight: bold;
      margin-bottom: 30px;
    }

    .subtitle {
      font-size: 20px;
      font-weight: 700;
      color: #38c5bc;
      font-weight: bold;
    }

    .explainInfo {
      font-size: 14px;
      font-weight: 400;
      color: #fff;
      line-height: 1.8;
      margin: 16px 0 32px 0;
    }
  }
}

.preview_mobile {
  width: 400px;
  margin: 0 auto;
  position: relative;

  .question_content {
    width: 340px;
    height: 670px;
    overflow-y: scroll;
    position: absolute;
    left: 30px;
    top: 75px;
    padding: 0 10px;
    box-sizing: border-box;

    .quesTitle {
      font-size: 15px;
      margin-bottom: 20px;
    }

    .subtitle {
      font-size: 15px;
    }
  }


}

::v-deep .preview_mobile .ant-radio-group {
  flex-wrap: wrap;
}

::v-deep .preview_mobile .ant-checkbox-group {
  flex-wrap: wrap;
}

::v-deep .preview_mobile .ant-radio-wrapper {
  font-size: 12px
}

::v-deep .preview_mobile .topic_select .box .body_box {
  width: 170px;
  height: 300px;
}

::v-deep .preview_mobile .topic_select .box .body_box .point {
  width: 10px;
  height: 10px;
}

// ::v-deep .preview_mobile .topic_select .box {
//   display: inline-block;
// }

::v-deep .preview_mobile .topic_select .box span {
  font-size: 13px;
}

::v-deep .preview_mobile .ant-radio-wrapper {
  margin-bottom: 6px;
}

::v-deep .preview_mobile .topic_title {
  font-size: 13px;
  color: #fff;
}

::v-deep .preview_mobile .topic_item {
  margin-bottom: 10px !important
}

::v-deep .preview_mobile .topic_select {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

::v-deep .preview_mobile .topic_select .flex-1 {
  margin-left: 0 !important;
}

.mobileImg {
  width: 400px
}
</style>
